import React, { useContext, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import HomePage from './components/HomePage';
import LoginPage from './components/LoginPage';

//Branch
import BranchFormPage from './components/BranchFormPage';

//Book Request Page
import BookRequestPage from './components/BookRequestPage';
import BookRequestDetailPage from './components/BookRequestDetailPage';


//Expense Page
import OtherExpenseListPage from './components/OtherExpenseListPage';
import OtherExpenseFormPage from './components/OtherExpenseFormPage';


//Inventory Page
import StockBranchListPage from './components/StockBranchListPage';
import StockDetailPage from './components/StockDetailPage';
import StockBranchDetailPage from './components/StockBranchDetailPage';
import StockListPage from './components/StockListPage';
import StockCreatePage from './components/StockCreatePage';
import StockEntryPage from './components/StockEntryPage';
import StockTransferPage from './components/StockTransferPage';
import InventoryPriceFormPage from './components/InventoryPriceFormPage';
import InventoryPriceListPage from './components/InventoryPriceListPage';

//Student Page
import StudentListPage from './components/StudentListPage';
import StudentBucketListPage from './components/StudentBucketListPage';
import StudentBucketDetailPage from './components/StudentBucketDetailPage';
import StudentFormPage from './components/StudentFormPage';
import StudentProfilePage from './components/StudentProfilePage';
import StudentRequestLevelupPage from './components/StudentRequestLevelupPage';
import StudentLevelupRequestDetailPage from './components/StudentLevelupRequestDetailPage';
import StudentLevelupRequestApproveDetailPage from './components/StudentLevelupRequestApproveDetailPage';
import StudentLeaveFormPage from './components/StudentLeaveFormPage';
import StudentProgramEditPage from './components/StudentProgramEditPage';
import StudentProgressLevelListPage from './components/StudentProgressLevelListPage';
import StudentStatusEditPage from './components/StudentStatusEditPage';
import StudentSavingFormPage from './components/StudentSavingFormPage';
import StudentPurchasePage from './components/StudentPurchasePage';
import StudentMutationFormPage from './components/StudentMutationFormPage';



//public student
import PublicStudentListPage from './components/PublicStudentListPage';
import PublicStudentProfilePage from './components/PublicStudentProfilePage';
import PublicStudentFormPage from './components/PublicStudentFormPage';

//class
import ClassCreatePage from './components/ClassCreatePage';
import ClassDetailPage from './components/ClassDetailPage';
import ClassListPage from './components/ClassListPage';
import ClassPublicListPage from './components/ClassPublicListPage';


//Teacher Page
import TeacherListPage from './components/TeacherListPage';
import TeacherFormPage from './components/TeacherFormPage';
import TeacherProfilePage from './components/TeacherProfilePage';
import TeacherSalaryPage from './components/TeacherSalaryPage';


//Extra Time Page
import CreateExtraTimePage from './components/CreateExtraTimePage';
import ExtraTimeDetailPage from './components/ExtraTimeDetailPage';
import ExtraTimeListPage from './components/ExtraTimeListPage';
import TeacherBonusFormPage from './components/TeacherBonusFormPage';
import ExtraTimeMonthlyReportPage from './components/ExtraTimeMonthlyReportPage';

//Attendance
import TeacherAttendanceFormPage from './components/TeacherAttendanceFormPage';
import AttendanceMonthlyReportPage from './components/AttendanceMonthlyReportPage';
import TeacherLeaveFormPage from './components/TeacherLeaveFormPage';
import TeacherLeaveDetailPage from './components/TeacherLeaveDetailPage';

//Payment Page
import PaymentReportMonthlyPage from './components/PaymentReportMonthlyPage';
import PaymentReportDailyPage from './components/PaymentReportDailyPage';
import SppPaymentPage from './components/SppPaymentPage';


//Utils Page
import Sidebar from './components/Sidebar';
import AuthContext from './context/AuthContext';
import UserMenu from './components/UserMenu';
import ErrorPage from './components/ErrorPage';
import SuccessPage from './components/SuccessPage';
import ResetPasswordPage from './components/ResetPasswordPage';

//Cost Page
import CostListPage from './components/CostListPage';
import CostFormPage from './components/CostFormPage';
import './App.css';
import ExtraFeeFormPage from './components/ExtraFeeFormPage';
import ExtraFeeListPage from './components/ExtraFeeListPage';
import IncomeListPage from './components/IncomeListPage';

//Program Page

import CreateProgramEventPage from './components/CreateProgramEventPage';

//Savings
import SavingsMonthlyReportPage from './components/SavingsMonthlyReportPage';

//Student Schedule Page
import StudentScheduleAssignPage from './components/StudentScheduleAssignPage';
//import StudentChangeSchedulePage from './components/StudentChangeSchedulePage';
import ScheduleReportPage from './components/ScheduleReportPage';



const routes = [
  //utils
  { path: "/home", element: <HomePage /> },
  { path: "/success", element: <SuccessPage /> },
  { path: "/error", element: <ErrorPage /> },
  { path: "/resetpassword", element: <ResetPasswordPage /> },
  //branch
  { path: "/branch/create", element: <BranchFormPage /> },
  //expense 
  { path: "/expense/otherexpense/list", element: <OtherExpenseListPage /> },
  { path: "/expense/otherexpense/create", element: <OtherExpenseFormPage /> },
  //income
  { path: "/income/list", element: <IncomeListPage /> },
  //price list
  { path: "/cost/list", element: <CostListPage /> },
  { path: "/cost/edit/:costId", element: <CostFormPage /> },
  { path: "/extrafee/list", element: <ExtraFeeListPage /> },
  { path: "/extrafee/edit/:extraFeeId", element: <ExtraFeeFormPage /> },
  { path: "/inventory/pricelist", element: <InventoryPriceListPage /> },
  { path: "/inventory/priceEdit/:inventoryId", element: <InventoryPriceFormPage /> },
  { path: "/program/event/create", element: <CreateProgramEventPage /> },
  //inventory
  { path: "/inventory/list", element: <StockListPage /> },
  { path: "/inventoryBranch/list", element: <StockBranchListPage /> },
  { path: "/inventory/createnewitem", element: <StockCreatePage /> },
  { path: "/inventory/create", element: <StockEntryPage /> },
  { path: "/inventory/transfer", element: <StockTransferPage /> },
  { path: "/inventory/detail/:inventoryId", element: <StockDetailPage /> },
  { path: "/inventory/branchDetail/:inventoryBranchId", element: <StockBranchDetailPage /> },
  { path: "/inventory/bookRequest/create", element: <BookRequestPage /> },
  { path: "/inventory/bookRequest/detail/:bookRequestId", element: <BookRequestDetailPage /> },
  //student
  { path: "/student/list", element: <StudentListPage /> },
  { path: "/student/create", element: <StudentFormPage /> },
  { path: "/student/detail/:studentId", element: <StudentProfilePage /> },
  { path: "/student/levelup/create", element: <StudentRequestLevelupPage /> },
  { path: "/student/levelup/detail/:levelupRequestId", element: <StudentLevelupRequestDetailPage /> },
  { path: "/student/levelup/approveDetail/:levelupRequestId", element: <StudentLevelupRequestApproveDetailPage /> },
  { path: "/student/bucket/list", element: <StudentBucketListPage /> },
  { path: "/student/bucket/detail/:bucketId", element: <StudentBucketDetailPage /> },
  { path: "/student/leave/create", element: <StudentLeaveFormPage /> },
  { path: "/student/mutation/create", element: <StudentMutationFormPage /> },
  { path: "/student/program/edit/:studentId", element: <StudentProgramEditPage /> },
  { path: "/student/progressLevel/list", element: <StudentProgressLevelListPage /> },
  { path: "/student/status/edit/:studentId", element: <StudentStatusEditPage /> },
  { path: "/student/saving/create/:studentId", element: <StudentSavingFormPage /> },
  { path: "/student/purchase/create", element: <StudentPurchasePage /> },
  
  //public student
  { path: "/student/public/list", element: <PublicStudentListPage /> },
  { path: "/student/public/create", element: <PublicStudentFormPage /> },
  { path: "/student/public/detail/:studentId", element: <PublicStudentProfilePage /> },
  //class
  { path: "/student/class/list", element: <ClassListPage /> },
  { path: "/student/class/public/list", element: <ClassPublicListPage /> },
  { path: "/student/class/create", element: <ClassCreatePage /> },
  { path: "/student/class/detail/:studentId", element: <ClassDetailPage /> },
  { path: "/student/class/public/detail/:publicStudentId", element: <ClassDetailPage /> },
  //teacher
  { path: "/teacher/list", element: <TeacherListPage /> },
  { path: "/teacher/create", element: <TeacherFormPage /> },
  { path: "/teacher/edit/:teacherId", element: <TeacherFormPage /> },
  { path: "/teacher/detail/:teacherId", element: <TeacherProfilePage /> },
  { path: "/teacher/extratime/create", element: <CreateExtraTimePage /> },
  { path: "/teacher/extratime/detail/:extraTimeId", element: <ExtraTimeDetailPage /> },
  { path: "/teacher/extratime/list", element: <ExtraTimeListPage /> },
  { path: "/teacher/extratime/monthlyReport", element: <ExtraTimeMonthlyReportPage /> },
  { path: "/teacher/attendance/create", element: <TeacherAttendanceFormPage /> },
  { path: "/teacher/attendance/monthlyReport", element: <AttendanceMonthlyReportPage /> },
  { path: "/teacher/leave/create", element: <TeacherLeaveFormPage /> },
  { path: "/teacher/leave/detail/:teacherLeaveId", element: <TeacherLeaveDetailPage /> },
  { path: "/teacher/bonus/create/:teacherId", element: <TeacherBonusFormPage /> },
  { path: "/teacher/salaryDetail/:teacherId", element: <TeacherSalaryPage /> },
  //payment
  { path: "/paymentreportmonthly", element: <PaymentReportMonthlyPage /> },
  { path: "/paymentreportdaily", element: <PaymentReportDailyPage /> },
  { path: "/spp-payment-details/:studentId", element: <SppPaymentPage /> },

  //savings report
  { path: "/student/saving/report", element: <SavingsMonthlyReportPage /> },

  //student scheduler
  { path: "/student/schedule/assign", element: <StudentScheduleAssignPage /> },
  //{ path: "/student/schedule/view/:studentId", element: <StudentChangeSchedulePage /> },
  { path: "/schedule/report", element: <ScheduleReportPage /> },
  //{ path: "/schedule/report", element: <ScheduleReportPage /> },

]

const App = () => {
  const { user, permissions } = useContext(AuthContext);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  // Check if current path is login page
  const isLoginPage = window.location.pathname === '/login';

  return (
    <>
      {!isLoginPage && user && (
        <>
          <Sidebar isCollapsed={isSidebarCollapsed} toggleSidebar={() => setIsSidebarCollapsed(!isSidebarCollapsed)} />
          <UserMenu />
        </>
      )}
      <div className={isLoginPage ? 'login-page-content' : `main-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          {routes.map(route => (
            permissions.some(p => p.path === route.path) && (
                <Route key={route.path} path={route.path} element={route.element} />
            )
          ))}
          <Route path="*" element={<Navigate to={user ? "/home" : "/login"} />} />
          
        </Routes>
      </div>
    </>
  );
};

export default App;
